// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"_ba2fe95","submit":"_51d4ea6","firstGroup":"_36db385","bottomText":"_7142604","verifyLater":"_98c126d"};